document.documentElement.className = document.documentElement.className.replace(/\bno-js\b/g, "") + "js"

if (window.location.hash) { setTimeout(function () { window.scrollTo(0, 0); }, 2); }

jQuery(document).ready(function ($) {

    /*-----------------------------------------------------------------------------GLOBAL ON LOAD----*/

    var LazyLoading = (function () {
        var instance = new LazyLoad();

        function lazyBGImages() {
            var $bgImages = $('[data-bg]:not(.lazy)');
            if ($bgImages.length) {
                $bgImages.each(function () {
                    $(this).addClass('lazy');
                });
            }
            instance.update();
        }

        function update() {
            lazyBGImages();
        }

        lazyBGImages();

        return {
            update: update
        }
    }());

    var Cookie = (function () {
        /**
         * get cookie value
         * @param   {String} strName - cookie name
         * @returns {String}         - cookie value
         */
        var get = function (strName) {
            // seperate cookies into array
            var arrCookies = decodeURIComponent(document.cookie).split("; ");
            // initiate cookie value return
            var strCookieValue;
            // remove whitespace
            strName = strName.trim();

            // cycle through cookies
            arrCookies.forEach(function (strCookie) {
                // find cookie and return value
                if (strCookie.indexOf(strName + "=") === 0) {
                    strCookieValue = strCookie.split('=')[1];
                }
            });

            // if cookie value is undefined
            if (!strCookieValue) console.warn("Cookie '" + strName + "' does not exist");
            // return cookie value
            return strCookieValue;

        };
        /**
         * Set cookies
         * @param {String} strName        - cookie name
         * @param {String} strValue       - cookie value
         * @param {Number} [intExpInDays] - days until cookie expires
         * @param {String} [strPath]      - path where cookie is accessible
         */
        var set = function (strName, strValue, intExpInDays, strPath) {
            var strExpires = "";
            /* if strPath is undefined
             * default to domain root */
            strPath = strPath || "/";

            // if intExpInDays is defined
            if (intExpInDays) {
                var objExpireDate = new Date();
                // set time to expiration date
                objExpireDate.setTime(objExpireDate.getTime() + (intExpInDays * 24 * 60 * 60 * 1000));
                // format to cookie param
                strExpires = "expires=" + objExpireDate.toUTCString() + ";";
            }
            // set cookie
            document.cookie = strName + "=" + strValue + ";" + strExpires + "path=" + strPath;
        };

        /**
         * remove cookie
         * @param {String} strName - cookie name
         */
        var remove = function (strName) {
            // if cookie exists - set expiration to day before
            if (get(strName) !== undefined) set(strName, '_', -1);
        };

        return {
            get: get,
            set: set,
            delete: remove,
        };
    })();

    var SmoothScroll = (function () {
        var $anchorLinks = $('a[href^="#"]').not('a[href="#"]');

        $('a[href="#"]').click(
            function (e) { e.preventDefault(); return; }
        );

        function goTo(target) {
            if (target === "" || !$(target).length) { return; }
            var scrollPos = typeof target === 'number' ? target : $(target).offset().top;

            if (window.innerWidth >= 720) {
                scrollPos -= $('header').outerHeight();
            } else {
                scrollPos -= $('header').outerHeight() * 2;
            }

            $('html, body').stop().animate({
                'scrollTop': scrollPos - 32
            }, 1200, 'swing', function () {
                if (typeof target === 'string') {

                    if (window.location.hash) {
                        // window.location.hash = target;
                    }
                }
            });
        }

        if (window.location.hash) {
            setTimeout(function () {
                goTo(window.location.hash);
            }, 500);
        }

        if ($anchorLinks.length) {
            $anchorLinks.on('click', function (e) {
                if (!$("#" + this.hash.replace('#', '')).length) { return; }
                e.preventDefault();
                goTo(this.hash);
            });
        }

        return { to: goTo }
    }());

    //Global function to toggle simple accordions
    var Accordions = (function () {
        var $accordions = $('.accordion');
        if (!$accordions.length) { return; }

        $accordions.each(function () {
            if ($(this).hasClass('active')) {
                $(this).find('.accordion__content').show();
            }
        });

        $accordions.find('.accordion__trigger').click(function (e) {
            var $this = $(this);
            var $accordion = $this.parent();
            var $content = $accordion.find('.accordion__content');
            var $siblings = $accordion.siblings();

            if ($accordion.hasClass('active')) {
                $accordion.removeClass('active');
                $content.slideUp('fast');
            } else {
                $accordion.addClass('active');
                $siblings.removeClass('active').find('.accordion__content').slideUp('fast');
                $content.slideDown('fast');
            }
        })

    }());

    var Forms = (function () {
        var InputMasks = (function () {
            var $masks = $('[data-mask]');
            if (!$masks.length) { return; }

            /**
             * Key Codes:
             * 8    - backspace
             * 13   - enter
             * 16   - shift
             * 18   - alt
             * 20   - caps
             * 27   - esc
             * 37   - left arrow
             * 38   - up arrow
             * 39   - right arrow
             * 40   - down arrow
             * 46   - delete
             **/
            var exclude_keys = [8, 13, 16, 18, 20, 27, 37, 38, 39, 40, 46];

            $('[data-mask]').keyup(function (e) {
                console.log(e.keyCode);
                if (exclude_keys.indexOf(e.keyCode) > -1) { return; }

                switch (this.dataset.mask) {
                    case 'digits':
                        var x = this.value.replace(/\D/g, '');
                        this.value = x;
                        break;
                    case 'phone':
                        var x = this.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
                        console.log(x);
                        this.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
                        break;
                    case 'ssn': {
                        var x = this.value.replace(/\D/g, '').match(/^(\d{0,3})(\d{0,2})(\d{0,4})/);
                        this.value = !x[2] ? x[1] : x[1] + '-' + x[2] + '-' + x[3];
                    }
                }
            });
        }());

        //Plugin used for form validation
        var parselyOptions = {
            classHandler: function (parsleyField) {
                var $element = parsleyField.$element;
                if ($element.parent().hasClass('select-menu')) {
                    return $element.parent();
                }
                return $element;
            },
            errorsContainer: function (parsleyField) {
                var $element = parsleyField.$element;
                var $fieldContainer = $element.closest('.form-field');
                if ($fieldContainer) {
                    return $fieldContainer;
                }
            }
        };

        //Global function to set form state classes
        var formStates = (function () {
            $formInputs = $('form :input');
            if (!$formInputs.length) { return; }

            $formSelectMenus = $('.select-menu select, .ginput_container_select select');

            function isGFormInput($el) {
                return $el.parent().hasClass('ginput_container') ? $el.parent().parent() : $el;
            }

            function setFilled($input) {
                $input.addClass('filled');
            }

            function removeFilled($input) {
                $input.removeClass('filled');
            }

            function setFocused() {
                $(this).addClass('focused');
            }

            function removeFocused() {
                $(this).removeClass('focused');
            }

            function checkInput(e) {
                if (this.type == 'button' ||
                    this.type == 'range' ||
                    this.type == 'submit' ||
                    this.type == 'radio' ||
                    this.type == 'checkbox' ||
                    this.type == 'reset') { return; }

                var $this = $(this);
                var $parent = $this.parent();
                var is_selectMenu = $parent.hasClass('select-menu') || $parent.hasClass('ginput_container_select');

                var $input = is_selectMenu ? $parent : $this;

                switch (this.type) {
                    case 'select-one':
                    case 'select-multiple':
                        if (this.value !== '') {
                            setFilled($input);
                        } else {
                            removeFilled($input);
                        }
                        break;
                    default:
                        if (this.value !== '') {
                            setFilled($input);
                        } else {
                            removeFilled($input);
                        }
                        break;
                }
            }

            $formInputs.each(checkInput);
            $formInputs.on('change', checkInput);
            $formInputs.on('focus', setFocused);
            $formInputs.on('blur', removeFocused);
            $formSelectMenus.on('focus', setFocused);
            $formSelectMenus.on('blur', removeFocused);

        }());
        return { options: parselyOptions }
    }());

    //Global function top open / close lightboxes
    var PDMLightbox = (function () {
        //Lightbox reset - This lightbox is empty and present on all pages
        var $lightbox = $('.pdm-lightbox--reset');

        //it's content can be filled from various sources
        //after close, the content is wiped
        var $lightbox_content = $('.pdm-lightbox--reset .pdm-lightbox__content');

        $('body').on('click', '[data-lightbox-iframe],[data-lightbox-content],[data-lightbox-target],[data-lightbox-wc-target],.lightbox-trigger', function (e) {

            e.preventDefault();

            var iframe = $(this).data('lightbox-iframe');

            if (iframe) {
                var youtubePattern = /(?:http?s?:\/\/)?(?:www\.)?youtu(be\.com\/|\.be\/)(embed\/(.+)(\?.+)?|watch\?v=(.+)(\&.+)?)/g;
                var vimeoPattern = /(?:http?s?:\/\/)?:\/\/(www\.|player\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|video\/|)(\d+)(?:|\/\?)/g;

                if (youtubePattern.test(iframe)) {
                    classes += ' youtube-vid'

                    replacement = '<div class="spacer"><iframe width="560" height="315" frameborder="0" allowfullscreen src="//www.youtube.com/embed/$3?rel=0&autoplay=1&modestbranding=1&iv_load_policy=3" /></div>';

                    iframe = iframe.replace(youtubePattern, replacement);

                }

                if (vimeoPattern.test(iframe)) {

                    classes += ' vimeo-vid'

                    replacement = '<div class="spacer"><iframe width="560" height="315" frameborder="0" allowfullscreen src="//player.vimeo.com/video/$3?rel=0&autoplay=1&modestbranding=1&iv_load_policy=3" /></div>';

                    iframe = iframe.replace(vimeoPattern, replacement);

                }

                $lightbox_content.html('<div class="video-embed">' + iframe + '</div>');
            } else {
                if ($(this).data('lightbox-content')) {
                    var content = $(this).data('lightbox-content');
                } else if ($(this).data('lightbox-target')) {
                    var target = $(this).data('lightbox-target');
                    var content = $('#' + target).html();
                } else if ($(this).data('lightbox-wc-target')) {
                    var target = $(this).data('lightbox-wc-target');
                    // var target_alt = $(this).data('thumb-alt');
                    var content = target;
                } else {
                    var content = $(this).next('.lightbox-content').html();
                }
                $lightbox_content.html(content);

            }

            var classes = $(this).data('lightbox-classes');
            $lightbox.addClass('active').addClass(classes);

        });

        function closeModal($lightbox) {
            $lightbox.removeClass('active');
            $('body').removeClass('noScroll');
            //wait before removing classes till lightbox closses
            if ($lightbox.hasClass('pdm-lightbox--reset')) {
                setTimeout(function () {
                    $lightbox.find('.pdm-lightbox__content').empty();
                    $lightbox.attr('class', 'pdm-lightbox pdm-lightbox--reset');
                }, 750);
            }
        }

        function openModal($lightbox) {
            $lightbox.addClass('active');
            $('body').addClass('noScroll');
        }

        function updateModal($lightbox, $content) {
            $lightbox.find('.pdm-lightbox__content').html($content);
        }

        $('.pdm-lightbox').on('click', function (e) {
            if (e.target == this) {
                closeModal($(this));
            }
        });

        $('.pdm-lightbox__close').click(function (e) {
            e.stopPropagation();
            closeModal($(this).closest('.pdm-lightbox'));
        });
        return {
            close: closeModal,
            open: openModal,
            update: updateModal
        };
    }());

    //******************************************************Everything under this is optional, feel free to delete

    var Header = (function () {
        var $body = $('body');
        var $header = $('header.gheader');
        var $nav = $header.find('nav.global');
        var $adminBar = $('#wpadminbar');

        var header_height = $header.innerHeight();
        var adminbar_height = $adminBar.length ? $adminBar.innerHeight() : 0;

        if (window.innerWidth < 960) { $nav.css({ marginTop: header_height + adminbar_height }); }

        var BurgerMenu = (function () {
            var $burgerMenu = $header.find('.menu-burger');
            var $text = $burgerMenu.find('.menu-burger__text');

            function activate() {
                $burgerMenu.addClass('active').attr('title', 'Close');
                $text.text('Close');
                $nav.addClass('active');
                $body.addClass('no-scroll');

                $header.css({ position: 'fixed', top: adminbar_height });
                $body.css({ marginTop: header_height });
            }

            function reset() {
                $burgerMenu.removeClass('active').attr('title', 'Menu');
                $text.text('Menu');
                $nav.removeClass('active').find('.active').removeClass('active');
                $body.removeClass('no-scroll');

                $header.css({ position: 'sticky', top: 0 });
                $body.css({ marginTop: 0 });
            }

            $burgerMenu.click(function () {
                var $this = $(this);

                if ($this.hasClass('active')) { reset(); } else { activate(); }
            });

            return { close: reset }
        }());

        var DropdownMenus = (function () {
            var $menus = $('.menu');
            var $dropmenus = $menus.find('.dropdown.menu-item');
            var $mobileArrow = $dropmenus.find('.mobile-arrow');

            function toggleDropdown(e) {
                e.preventDefault();

                var $this = $(this);
                var $menuItem = $this.parent();

                console.log($menuItem);

                if ($menuItem.hasClass('active')) {
                    $menuItem.removeClass('active');
                } else {
                    $menuItem.addClass('active');
                }
            }

            $mobileArrow.click(toggleDropdown);
        }());

        var StickyHeader = (function () {
            if (!$header.hasClass('sticky')) { return; }

            if (window.scrollY) {
                $header.addClass('sticky--scrolled');
            }

            $(window).on('scroll', function () {

                if ($adminBar.length) {
                    $header.css({ top: adminbar_height })
                }
                if (window.scrollY) {
                    $header.addClass('sticky--scrolled');

                } else if (window.scrollY === 0) {
                    $header.removeClass('sticky--scrolled');
                    if ($adminBar.length) {
                        $header.css({ top: 0 })
                    }
                }

            });
        }());

        var MegaMenu = (function () {
            var $menus = $('.megamenu');
            var $dropmenus = $menus.find('.megamenu__menu-item--dropdown');
            var $backToMenu = $dropmenus.find('.megamenu-submenu__back');
            var $mobileArrow = $dropmenus.find('.megamenu__arrow');
            var $dropdownHeader = $dropmenus.find('.megamenu__link[href="#"]');

            function toggleDropdown(e) {
                e.preventDefault();

                var $this = $(this);
                var $menuItem = $this.parent();

                $dropmenus.not($menuItem).removeClass('active');

                if ($menuItem.hasClass('active')) {
                    $menuItem.removeClass('active');
                } else {
                    $menuItem.addClass('active');
                }

            }

            $mobileArrow.click(toggleDropdown);
            $dropdownHeader.click(toggleDropdown);
            $backToMenu.click(function () {
                var $menu = $(this).closest('.megamenu__menu-item');
                $menu.removeClass('active');
            });

        }());

        var HeaderBanner = (function () {
            var $banner = $('.header-banner');
            if (!$banner.length) { return; }

            var $close = $banner.find('.header-banner__close');

            if (Cookie.get('hide-banner')) {
                $banner.hide();
                return;
            }

            $close.click(function () {
                $banner.slideUp();

                Cookie.set('hide-banner', true);
            });
        }());

        window.addEventListener('resize', function () {
            BurgerMenu.close();

            if (window.innerWidth < 960) {
                $nav.css({ marginTop: header_height + adminbar_height })
            } else {
                $nav.css({ marginTop: 0 });
            }
        });
    }());

    var LoadMore = (function () {
        var $loadmore = $('#loadmore');
        if (!$loadmore.length) { return; }

        var $loadmore_text = $loadmore.text();

        $loadmore.click(function () {
            var $this = $(this);
            var $postlist = $this.siblings('.blog-posts');
            var query = WP.query;
            var page = WP.current_page;
            var max = WP.max_page;

            var data = {
                action: 'load_more_posts',
                query: query,
                page: page
            };

            $.ajax({
                url: ajaxURL,
                type: 'post',
                data: data,
                beforeSend: function () {
                    $loadmore.attr('disabled', true).text('Loading Posts');
                },
                error: function (res) {
                    res = JSON.parse(res);
                    console.log(res);
                },
                success: function (posts) {
                    if (posts) {
                        page = WP.current_page++;
                        $loadmore.attr('disabled', false).text($loadmore_text);
                        $postlist.append(posts);
                        LazyLoading.update();

                        if (WP.current_page >= max) { $loadmore.remove(); }
                    } else {
                        $loadmore.remove();
                    }
                }
            });
        });
    }());

    var TestimonialSlider = (function () {
        var $section = $('.testimonials');
        if (!$section.length) { return; }

        $section.each(function () {
            var $this = $(this);

            var $slider = $this.find('.slider');
            var $prev = $this.find('.slider__prev');
            var $next = $this.find('.slider__next');

            var isTypeImage = $this.hasClass('testimonials--img');

            console.log($this.find('.testimonials__featimg'));

            $slider.flickity({
                contain: true,
                prevNextButtons: false,
                pageDots: false,
                wrapAround: true
            });

            function changeBGImage() {
                var data = $slider.data('flickity');
                var selectedIndex = data['selectedIndex'];

                $this.find('.testimonials__featimg').removeClass('active').filter('[data-slide="' + selectedIndex + '"]').addClass('active');
            }

            $prev.on('click', function () {
                $slider.flickity('previous', true);

                if (isTypeImage) {
                    changeBGImage();
                }
            });

            $next.on('click', function () {
                $slider.flickity('next', true);

                if (isTypeImage) {
                    changeBGImage();
                }
            });
        });

    }());

    var ClassSlider = (function () {
        var $section = $('.classes');
        if (!$section.length) { return; }

        var $slider = $section.find('.slider');
        var $select = $section.find('[name="slider-select"]');
        var $nav = $section.find('.classes-slider__nav .btn');

        $slider.flickity({
            prevNextButtons: false,
            pageDots: false
        });

        $select.change(function () {
            var activeSlide = this.value;
            $slider.flickity('select', activeSlide);
        });

        $nav.click(function () {
            var $this = $(this);
            var activeSlide = this.dataset.slide;

            $nav.removeClass('active').filter(this).addClass('active');

            $slider.flickity('select', activeSlide);
        });

        $section.each(function () {
            var $this = $(this);

            var $prev = $this.find('.slider__prev');
            var $next = $this.find('.slider__next');

            $prev.on('click', function () {
                $slider.flickity('previous', true);
            });

            $next.on('click', function () {
                $slider.flickity('next', true);
            });
        });

    }());

    var PostSlider = (function () {
        var $section = $('.post-slider');
        if (!$section.length) { return; }

        $section.each(function () {
            var $this = $(this);

            var $slider = $this.find('.slider');
            var $prev = $this.find('.slider__prev');
            var $next = $this.find('.slider__next');

            $slider.flickity({
                prevNextButtons: false,
                pageDots: false,
                groupCells: true,
                cellAlign: 'left'
            });

            $prev.on('click', function () {
                $slider.flickity('previous', true);
            });

            $next.on('click', function () {
                $slider.flickity('next', true);
            });
        });
    }());

    var GallerySlider = (function () {
        var $section = $('.gallery-slider-content');
        if (!$section.length) { return; }

        $section.each(function () {
            var $this = $(this);

            var $slider = $this.find('.slider');
            var $prev = $this.find('.slider__prev');
            var $next = $this.find('.slider__next');

            $slider.flickity({
                prevNextButtons: false,
                groupCells: true,
                cellAlign: 'left'
            });

            $prev.on('click', function () {
                $slider.flickity('previous', true);
            });

            $next.on('click', function () {
                $slider.flickity('next', true);
            });
        });
    }());

    var GallerySlider = (function () {
        var $section = $('.gallery-slider');
        if (!$section.length) { return; }

        $section.each(function () {
            var $this = $(this);

            var $slider = $this.find('.slider');
            var $prev = $this.find('.slider__prev');
            var $next = $this.find('.slider__next');

            $slider.flickity({
                prevNextButtons: false,
                groupCells: true,
                cellAlign: 'left'
            });

            $prev.on('click', function () {
                $slider.flickity('previous', true);
            });

            $next.on('click', function () {
                $slider.flickity('next', true);
            });
        });
    }());

    var FAQsFilter = (function () {
        var $section = $('.faqs');
        if (!$section.length) { return; }

        var $filters = $section.find('.faqs__filter');
        var $select = $section.find('.faqs__select');
        var $lists = $section.find('.faqs__list');
        $filters.click(function () {
            var catID = this.dataset.cat;
            $filters.removeClass('active').filter(this).addClass('active');
            $lists.removeClass('active').filter('[data-cat="' + catID + '"]').addClass('active');
            $select.val(catID).trigger('change');
        });

        $select.change(function () {
            var catID = this.value;
            $filters.removeClass('active').filter('[data-cat="' + catID + '"]').addClass('active');
            $lists.removeClass('active').filter('[data-cat="' + catID + '"]').addClass('active');
        });
    }());

    var ClassSchedule = (function () {
        var $section = $('.class-schedule');
        if (!$section.length) { return; }

        var club_id = $section.data('club');
        var $calendar = $section.find('.class-schedule__calendar');
        var $day_selector = $section.find('.class-schedule__header');
        var $filter_date = $section.find('#eventDateRange');
        var $filter_class = $section.find('#eventClass');
        var $filter_instructor = $section.find('#eventInstructor');
        var $week_day = $section.find('.class-schedule__day');
        var $filter = $section.find('.class-schedule__filter');

        var date_range = $section.attr('data-range');
        var filter_range = $filter_date.attr('data-range');

        function renderOptions(options, first_label) {
            if (!first_label) first_label = 'Select Option';

            var html = '<option value="">' + first_label + '</option>';
            options.forEach(function (i) {
                html += '<option value="' + i + '">' + i + '</option>';
            });

            return html;
        }

        function init() {

            $filter_date.change(function () {

                var selected_date = this.value.replaceAll('-', '/');
                var new_date = new Date(selected_date);
                var clone_date = new Date(selected_date);

                var week_sunday = new Date(clone_date.setDate(new_date.getDate() - new_date.getDay()));
                var next_sunday = new Date(clone_date.setDate(new_date.getDate() - new_date.getDay() + 7));

                var range = week_sunday.toLocaleDateString('en-CA') + ',' + next_sunday.toLocaleDateString('en-CA');

                this.dataset.range = range;
                filter_range = range;
            });

            $section.on('click', '.class-schedule__header', function () {
                $section.find('.class-schedule__day').removeClass('active')
                    .filter('[data-day="' + this.dataset.day + '"]')
                    .addClass('active');

            });

            $filter.click(function () {
                $filter_class = $section.find('#eventClass');
                $filter_instructor = $section.find('#eventInstructor');

                if (filter_range !== date_range) {

                    var data = {
                        action: 'get_schedule',
                        range: filter_range,
                        club: club_id
                    };

                    $.ajax({
                        url: ajaxURL,
                        type: 'post',
                        data: data,
                        beforeSend: function () {
                            $calendar.addClass('loading');
                            $filter_class.attr('disabled', true);
                            $filter_instructor.attr('disabled', true);
                            $filter.attr('disabled', true);
                        },
                        error: function (res) {
                            res = JSON.parse(res);
                            console.log(res);
                        },
                        success: function (res) {
                            res = JSON.parse(res);
                            console.log(res);

                            $section.attr('data-range', filter_range);
                            date_range = filter_range;

                            $calendar.html(res.schedule);

                            var class_list = renderOptions(res.class_list, 'Select Class');
                            var instructors = renderOptions(res.instructors, 'Select Instructor');

                            $filter_class.val('').html(class_list).trigger('change');
                            $filter_instructor.val('').html(instructors).trigger('change');

                            $calendar.removeClass('loading');
                            $filter_class.attr('disabled', false);
                            $filter_instructor.attr('disabled', false);
                            $filter.attr('disabled', false);
                        }
                    });
                }

                var $event_cards = $section.find('.event-card');

                selected_filters = '';

                if ($filter_class.val()) {
                    selected_filters += '[data-class="' + $filter_class.val() + '"]';
                }

                if ($filter_instructor.val()) {
                    selected_filters += '[data-instructor="' + $filter_instructor.val() + '"]';
                }

                if (selected_filters == '') {
                    $event_cards.removeClass('hidden');
                } else {
                    $event_cards.addClass('hidden').filter(selected_filters).removeClass('hidden');
                }

            });
        }

        init();
    }());

    var ACFMaps = (function () {
        var $section = $('.acf-map');
        if (!$section.length) { return; }
        /**
         * initMap
         *
         * Renders a Google Map onto the selected jQuery element
         *
         * @date    22/10/19
         * @since   5.8.6
         *
         * @param   jQuery $el The jQuery element.
         * @return  object The map instance.
         */
        function initMap($el) {

            // Find marker elements within map.
            var $markers = $el.find('.marker');

            // Create gerenic map.
            var mapArgs = {
                zoom: $el.data('zoom') || 16,
                mapTypeId: google.maps.MapTypeId.ROADMAP
            };
            var map = new google.maps.Map($el[0], mapArgs);

            // Add markers.
            map.markers = [];
            $markers.each(function () {
                initMarker($(this), map);
            });

            // Center map based on markers.
            centerMap(map);

            // Return map instance.
            return map;
        }

        /**
         * initMarker
         *
         * Creates a marker for the given jQuery element and map.
         *
         * @date    22/10/19
         * @since   5.8.6
         *
         * @param   jQuery $el The jQuery element.
         * @param   object The map instance.
         * @return  object The marker instance.
         */
        function initMarker($marker, map) {

            // Get position from marker.
            var lat = $marker.data('lat');
            var lng = $marker.data('lng');
            var latLng = {
                lat: parseFloat(lat),
                lng: parseFloat(lng)
            };

            // Create marker instance.
            var marker = new google.maps.Marker({
                position: latLng,
                map: map
            });

            // Append to reference for later use.
            map.markers.push(marker);

            // If marker contains HTML, add it to an infoWindow.
            if ($marker.html()) {

                // Create info window.
                var infowindow = new google.maps.InfoWindow({
                    content: $marker.html()
                });

                // Show info window when marker is clicked.
                google.maps.event.addListener(marker, 'click', function () {
                    infowindow.open(map, marker);
                });
            }
        }

        /**
         * centerMap
         *
         * Centers the map showing all markers in view.
         *
         * @date    22/10/19
         * @since   5.8.6
         *
         * @param   object The map instance.
         * @return  void
         */
        function centerMap(map) {

            // Create map boundaries from all map markers.
            var bounds = new google.maps.LatLngBounds();
            map.markers.forEach(function (marker) {
                bounds.extend({
                    lat: marker.position.lat(),
                    lng: marker.position.lng()
                });
            });

            // Case: Single marker.
            if (map.markers.length == 1) {
                map.setCenter(bounds.getCenter());

                // Case: Multiple markers.
            } else {
                map.fitBounds(bounds);
            }
        }

        $section.each(function () {
            var map = initMap($(this));
        });
    }());

    var LocationDetails = (function () {
        var $section = $('.location-info');
        if (!$section.length) { return; }

        var $select = $section.find('#location-select');
        var $nav = $section.find('.location-info__nav .btn');
        var $content = $section.find('.location-details');

        function showContent(id) {
            $content.removeClass('active').filter('[data-id="' + id + '"]').addClass('active');
        }

        $select.change(function () {
            var id = this.value;
            $nav.filter('[data-id="' + id + '"]').trigger('click');
            showContent(id);
        });

        $nav.click(function () {
            var id = this.dataset.id;
            $nav.removeClass('active').filter(this).addClass('active');
            $select.val(id);
            showContent(id);
        });
    }());

    var Memberships = (function () {
        var $section = $('.memberships');
        if (!$section.length) { return; }

        var $steps = $section.find('.memberships__step');
        var $locations = $section.find('.location-card');
        var $plans = $section.find('.memberships__plans');
        var $form = $section.find('.memberships__signup');

        var $next = $section.find('.memberships__next');
        var $prev = $section.find('.memberships__prev');
        var $submit = $section.find('.memberships__submit');
        var $changeClub = $section.find('.memberships__back');

        var curStep = 0;
        var lastStep = $steps.length - 1;

        var $selectedLocation = $section.find('.memberships__selected-location');

        var selectedClub = 0;
        var selectedPlan = 0;

        var membership_url = 'https://onlinejoin.abcfitness.com/signup/plan';

        function getClubPlans(club) {
            var data = {
                action: 'get_plans',
                club: club
            };

            $.ajax({
                url: ajaxURL,
                type: 'post',
                data: data,
                beforeSend: function () {
                    $plans.addClass('loading');
                },
                error: function (res) {
                    res = JSON.parse(res);
                    console.log(res);
                },
                success: function (res) {
                    res = JSON.parse(res);
                    console.log(res);

                    $plans.removeClass('loading').html(res['plans']);
                }
            });
        };

        function changeStep(step) {
            $steps.removeClass('active').filter('[data-step="' + step + '"]').addClass('active');

            if (step != 0) {
                $prev.removeClass('hidden');
            } else {
                $prev.addClass('hidden');
                $submit.addClass('hidden');
                $next.removeClass('hidden');
            }

            if (step == lastStep) {
                $submit.removeClass('hidden');
                $next.addClass('hidden');
            }

            switch (step) {
                case 1:
                    $steps.filter('.memberships__step--plans').find('.memberships__submit').prop('disabled', true);
                    getClubPlans(selectedClub);
                    $changeClub.removeClass('hidden');
                    break;

                default:
                    break;
            }
        }

        $next.click(function () {
            curStep += 1;
            changeStep(curStep);
        });

        $prev.click(function () {
            curStep -= 1;
            changeStep(curStep);
        });

        $changeClub.click(function () {
            curStep = 0;
            changeStep(curStep);
        });

        $locations.click(function () {
            var $this = $(this);
            var club_id = $this.data('id');

            selectedClub = club_id;
            $submit.attr('data-club', selectedClub);

            $locations.removeClass('active').filter($this).addClass('active');

            $steps.filter('.memberships__step--locations').find('.memberships__next').prop('disabled', false);

            $selectedLocation.text($this.data('location'))
                .closest('.memberships__signup-location')
                .removeClass('hidden');
        });

        $plans.on('click', '.plan-card', function () {
            var $this = $(this);
            var plan_id = $this.data('plan');

            selectedPlan = plan_id;
            $submit.attr('data-plan', selectedPlan);

            $plans.find('.plan-card').removeClass('active').filter($this).addClass('active');
            $steps.filter('.memberships__step--plans').find('.memberships__submit').prop('disabled', false);
        });

        $submit.click(function () {
            var abc_url = membership_url + '?club=' + selectedClub + '&planId=' + selectedPlan;
            location.href = abc_url;
        });
    }());

    var Trainers = (function () {
        var $section = $('.trainers');
        if (!$section.length) { return; }

        var $trainers = $section.find('.trainer-card');

        var $loc_sections = $section.find('.trainers-locations__section');
        var $loc_select_dropdown = $section.find('#location-select');
        var $loc_select_btns = $section.find('.trainers-locations__nav .btn');

        var $class_select = $section.find('.trainers__class-nav .btn');

        $loc_select_dropdown.change(function () {
            $loc_sections.removeClass('active').filter('[data-location="' + this.value + '"]').addClass('active');

            $loc_select_btns.removeClass('active').filter('[data-location="' + this.value + '"]').addClass('active');
        });

        $loc_select_btns.click(function () {
            $loc_select_dropdown.val(this.dataset.location).trigger('change');
        });

        $class_select.click(function () {
            var $this = $(this);
            var selected_class = $this.attr('data-class');

            $class_select.removeClass('active').filter($this).addClass('active');

            if (selected_class == 0) {
                $trainers.removeClass('hidden');
            } else {
                $trainers.addClass('hidden').filter(function () {
                    var classes = this.dataset.classes.split(',');

                    if (classes.indexOf(selected_class) > -1) {
                        return true;
                    }
                    return false;

                }).removeClass('hidden');
            }
        });

    }());

    var ExpandContent = (function () {
        $expand_mobile = $(".expand_mobile");
        if (!$expand_mobile.length) { return; }
        $expand_mobile.next(".svg-icon").click(function () {
            $expand_mobile.css('height', 'auto');
            $(this).hide();
        });
    }());

    var TrainerVid = (function () {
        var $hero_trainer_vid = $(".hero--trainers__vid");
        if (!$hero_trainer_vid.length) { return; }

        $('body').on('click', '[data-vid]', function (e) {
            var vidlink = $(this).data('vid');

            $hero_trainer_vid.html(vidlink);
            $(".trainer-image--video").hide();
            $hero_trainer_vid.fadeIn('slow');
            $('.wp-video-shortcode').get(0).play();
        });

    }());
});
jQuery(document).ready(function ($) {

    if (!$('.woocommerce').length) { return; }

    var ProductDetailAccordions = (function () {
        var $section = $('.details-accordion');
        if (!$section.length) { return; }

        var $accordions = $section.find('.details-accordion__label');

        $accordions.click(function () {
            var $this = $(this);

            if ($this.hasClass('active')) {
                $this.removeClass('active');
            } else {
                $accordions.removeClass('active').filter($this).addClass('active');
            }

        });

    }());
});